import axios from 'axios'
// import { cleanStorage, getStorage } from '@/utils/storage'
import { Toast } from 'vant'
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API
  //之前的正式: 'https://xxc.51xxc.com/api/'   
  //新服务器接口：https://share-xxc.51xxc.com/api   
  //测试接口：https://test-xxc.51xxc.com/api
  //本地测试接口： http://192.168.1.106:17946/api/

  
  // baseURL: 'http://192.168.110.38:17946/api'
  baseURL: 'https://share-xxc.51xxc.com/api'
})

// request interceptor
service.interceptors.request.use(config => {
  localStorage.getItem('token') ? (config.headers['Authorization'] = localStorage.getItem('token')) : ''
  return config
})

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        localStorage.removeItem('token')
        // Code 被使用了
        reCodeLogin()
      } else if (res.code === 500) {
        
      } else {
        Toast(res.msg)
      }
      return Promise.reject(res)
    } else {
      return Promise.resolve(res)
    }
  },
  error => {
    // console.log('ERROR: ' + error)
    if (error.response.data.code === 401) {
      localStorage.removeItem('token')
      // 401
      reCodeLogin()
    } else {
      Toast(error.data.msg || '哎呀~请求出错了~')
      // Toast((error.response && error.response.data && error.response.data.message) || '哎呀~请求出错了~')
    }
    return Promise.reject(error)
  }
)

function reCodeLogin() {
  // let url = location.href
  // if (location.href.indexOf('code=') > 0) {
  //   url = location.href.substr(0, location.href.indexOf('code='))
  // }
  // cleanStorage()
  // location.replace(url)
}
export default service
